<template>
  <div class="container-page">
    <div>
      <p class="title-inner">Карточка типа мероприятия</p>
    </div>

    <div>
      <div class="row">
        <div class="col-12">
          <div class="form-group required">
            <ComponentInput
              v-model="item.name"
              label="Наименование"
              required
              maxLength="250"
              placeholder="Введите наименование"
            />
          </div>
        </div>
      </div>
      <div class="row mt-10">
        <div class="col-12">
          <div class="form-group required">
            <label class="form-label">Категория</label>
            <SelectMultiComponent
              required
              :options="categoryOptions"
              :modelValue="item.categoryId"
              mode="single"
              placeholder="Выберите категорию"
              @update:modelValue="onCategorySelect"
              @clear="onCategoryClear"
              canClear
              modifier="rectangular"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group required">
            <ComponentInput
              v-model="item.sortValue"
              label="Сортировка"
              required
              placeholder="Введите индекс сортировки"
              type="number"
            />
          </div>
        </div>
      </div>
      <div class="row mt-10">
        <CheckboxInput v-model="item.isActive" label="Запись активна" />
      </div>
    </div>

    <div>
      <ButtonComponent mod="gradient-bg" class="mr-8" @click="save">Сохранить</ButtonComponent>
      <ButtonComponent mod="gradient-bg" @click="close">Отмена</ButtonComponent>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';
  import Constants from '@/common/constants';

  import API from '../api/nsi';

  export default {
    name: 'MpkEventTypeCard',
    components: { CheckboxInput, ComponentInput, SelectMultiComponent, ButtonComponent },
    data() {
      return {
        id: this.$route.params.id,
        item: {
          name: '',
          isActive: true,
          categoryId: null,
          sortValue: null,
        },
        categories: [],
        apiRoute: 'mpkeventtype',
        apiRouteSecond: 'mpkEventTypeCategory',
        cardName: 'MpkEventTypeCard',
        listName: 'MpkEventTypes',
      };
    },
    computed: {
      categoryOptions() {
        return this.categories.map((category) => ({
          value: category.id,
          label: category.name,
        }));
      },
    },
    async created() {
      await this.loadCategories();
      this.loadCard();
    },
    methods: {
      async loadCard() {
        if (this.id > 0) {
          try {
            const response = await API.find(this.apiRoute, this.id);
            this.item = response.data;
          } catch (error) {
            console.error('Ошибка при загрузке карточки:', error);
          }
        }
      },
      async loadCategories() {
        API.search(this.apiRouteSecond, {}).then((response) => {
          this.categories = response.data.items;
        });
      },
      onCategorySelect(selectedId) {
        this.item.categoryId = selectedId;
      },
      onCategoryClear() {
        this.item.categoryId = null;
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        API.update(this.apiRoute, this.item)
          .then((response) => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            if (response && response.data.id) {
              this.$router.push({ name: this.cardName, params: { id: response.data.id, action: 'edit' } });
            }
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      close() {
        this.$router.push({ name: this.listName });
      },
    },
    setup: () => ({ v$: useVuelidate() }),
  };
</script>

<style lang="scss" scoped></style>
